import TempoAPI from './TempoAPI';

export default class RelatedArticlesAPI extends TempoAPI
{
    constructor()
    {
        super();
        this.serviceName = 'get_related_posts';
    }
    getRelatedPosts(postTags, postId, isEvent, handler)
    {
        const data = {
            postTags: postTags,
            postId: postId,
            isEvent: isEvent
        }
        this.makeAPICall(this.serviceName, data, handler);
    }
}